export const numberToEuroString = (value: number) =>
  `${value.toFixed(2).toString().replace('.', ',')}€`
